module.exports = __webpack_public_path__ + "static/media/22.f8f4443a.jpg";